var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup20Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 41,
    viewBox: "0 0 187 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6006 23.5662C6.37152 23.5662 4.56301 20.8952 4.56301 17.0834C4.56301 12.6038 6.70539 10.6562 10.6006 10.6562C12.4926 10.6562 14.3568 10.9623 16.1653 11.5744V7.6513C14.1342 7.03919 12.0196 6.73315 9.90507 6.73315C5.09165 6.73315 0 8.95899 0 17.1112C0 25.2912 5.09165 27.4893 9.90507 27.4893C12.0196 27.5171 14.1342 27.1832 16.1653 26.5711V22.6758C14.3846 23.2323 12.4926 23.5384 10.6006 23.5662Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8625 28.5465C57.5385 28.5465 62.4076 25.9868 62.4076 17.6954C62.4076 10.5171 58.9018 7.79035 55.1179 7.79035C52.7807 7.79035 50.7218 8.5416 48.6072 9.79364V0.33374H44.1277V27.4057C46.6596 28.1291 49.2472 28.5187 51.8625 28.5465ZM57.8445 17.9737C57.8445 22.7036 56.0639 24.846 51.9738 24.846C50.8609 24.846 49.7202 24.7069 48.6351 24.4843V13.4107C50.6105 12.2699 52.3355 11.7413 53.6432 11.7413C56.3699 11.7413 57.8445 13.7445 57.8445 17.9737ZM83.0802 23.427C80.91 24.1226 78.2111 24.6513 76.347 24.6513C72.4239 24.6513 70.1146 23.2045 70.0868 19.3648H83.4419V17.3337C83.4419 12.3812 81.7725 7.79035 74.8167 7.79035C68.9182 7.79035 65.3846 11.2404 65.3846 18.1684C65.3846 25.3468 68.8069 28.5465 75.2897 28.5465C78.0999 28.5465 80.4092 28.0735 83.0802 27.2666V23.427ZM70.0311 16.1373C70.0311 13.4941 71.5614 11.3239 74.5663 11.3239C78.239 11.3239 78.8511 13.9393 78.9067 16.1373H70.0311ZM99.2733 8.15206C96.1571 8.34683 93.8756 10.2388 91.7333 11.6022V8.26336H87.5041V28.1292H91.9558V15.247C94.599 14.0784 96.658 13.1602 99.2733 12.7707V8.15206Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.486 26.7103C108.399 26.6825 106.313 26.5156 104.254 26.2095V27.545C105.728 27.6841 108.232 27.9346 110.57 27.9346C115.272 27.9346 117.358 25.5696 117.358 22.1195C117.358 17.6678 114.047 17.2504 110.931 16.8887C107.62 16.4992 105.561 16.1653 105.561 13.0213C105.561 10.4616 107.259 9.18168 111.46 9.18168C112.935 9.18168 114.799 9.45993 116.412 9.6547V8.37484C114.799 8.2079 113.157 7.95749 111.321 7.95749C107.759 7.95749 104.226 9.07039 104.226 13.0769C104.226 17.5008 107.648 17.8626 110.792 18.2799C114.02 18.6973 116.023 19.0589 116.023 22.203C115.967 25.3748 113.853 26.7103 110.486 26.7103ZM123.813 9.5434H130.352V8.31917H123.813V4.14568H123.396L122.534 5.0082V8.31917H120.085L119.556 8.90345V9.5434H122.534V24.3175C122.534 27.1555 124.064 27.8789 126.011 27.8789C127.208 27.8789 128.516 27.6007 129.684 27.3503V26.0704C128.627 26.4321 127.514 26.6547 126.373 26.6825C124.982 26.6825 123.813 26.1539 123.813 24.2897V9.5434ZM134.386 8.31917H133.079V27.4894H134.358L134.386 8.31917ZM134.414 1.64159H133.051V4.5074H134.414V1.64159ZM148.187 26.7103C142.844 26.7103 140.313 23.149 140.313 17.9182C140.313 12.6039 142.872 9.12605 148.187 9.12605C150.412 9.12605 152.304 9.62687 154.169 10.239V8.90345C152.221 8.23569 150.162 7.90182 148.103 7.90182C143.818 7.90182 138.921 10.0164 138.921 17.9182C138.921 25.8478 143.846 27.9346 148.103 27.9346C150.162 27.9346 152.221 27.5729 154.169 26.9329V25.5974C152.277 26.293 150.245 26.6825 148.187 26.7103ZM170.918 8.31917H169.694V9.09823C169.694 14.4125 166.578 15.8871 164.046 16.8887L159.733 18.6138V0.0834961H158.453V27.4616H159.733V19.8658L164.463 17.9739L166.8 22.203C168.498 25.2635 169.75 27.6563 172.254 27.6841C172.421 27.6841 172.588 27.6841 172.754 27.6563V26.5712C170.696 26.5712 169.583 24.7349 167.913 21.6465L165.576 17.4174C169.638 15.6367 170.89 12.5761 170.89 8.79218V8.31917H170.918Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.408 0H177.512V0.695581H179.07V4.67432H179.877V0.695581H181.408V0ZM183.995 4.70213H184.941L186.165 0.973813H186.221V4.70213H187V0.0278504H185.692L184.524 3.86744L183.327 0.0278504H181.992V4.70213H182.771V0.973813H182.826L183.995 4.70213Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2635 6.81665H19.365L28.6301 32.9427L33.5827 30.689L25.2635 6.81665Z",
    fill: "url(#paint0_linear_5_1038)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4746 6.42725H41.3731L30.9116 40.0099H25.2357L35.4746 6.42725Z",
    fill: "url(#paint1_radial_5_1038)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_1038",
    x1: 29.9085,
    y1: 21.7132,
    x2: 20.5804,
    y2: 23.9163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#050311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5_1038",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-15.8838 44.8902) rotate(-42.1874) scale(215.895 34.9599)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33FFF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#33FFF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#5AD4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#CF55C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF22B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#D419B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#B011B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#920BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#7B06B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#6A03B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#6101B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#5E01BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E01BA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup20Logo);
export default __webpack_public_path__ + "static/media/Group_20logo.82a392ff99ac2daee1256577552a0840.svg";
export { ForwardRef as ReactComponent };